import { PrismaClient } from '@prisma/client';

// Avoid multiple instances of PrismaClient in dev (hot reload issue)
let prisma;

if (!global.prisma) {
  global.prisma = new PrismaClient({
    log: ['query', 'error', 'warn'],

    // log: process.env.NODE_ENV === 'development' ? ['query', 'error', 'warn'] : ['error'],
  });
}

prisma = global.prisma;

export { prisma };

